import { SkillsManagementModalController } from "PFModules/admin/skills_management/parts/modals/skills_management_modal_controller";
import { SkillsManagement } from "PFModules/admin/skills_management/skills_management";
import { SkillsManagementContextProvider } from "PFModules/admin/skills_management/table/contexts/skills_management_context_provider";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import NotFoundRoute from "../not_found_route";
import { WithLayout } from "../route_helpers";

export const SkillsManagementRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <WithLayout layout={{ sidebar: "admin" }}>
      <Switch>
        <Route path={path}>
          <SkillsManagementContextProvider>
            <SkillsManagement />
            <Route exact path={`${path}/:modalPage/:importPage?`}>
              <SkillsManagementModalController />
            </Route>
          </SkillsManagementContextProvider>
        </Route>
        <Route path={"*"}>
          <NotFoundRoute />
        </Route>
      </Switch>
    </WithLayout>
  );
};
